export enum OrderType {
    SUBSCRIPTION = 'S',
    SUBSCRIPTION_PERIOD = 'SP',
    REFUND = 'R',
    REFUND_PERIOD = 'RP',
    EXTERNAL_TRANSFER = 'E',
    INTERNAL_TRANSFER = 'I',
}
